export const teamsKeys = {
  all: ['teams'] as const,
  byId: (id: string) => [...teamsKeys.all, id] as const,
  members: (id: string) => [...teamsKeys.byId(id), 'members'] as const,
};
